export default "__VITE_ASSET__B73aNaeb__"